import { Scenario } from '../services/types/serviceSettingTypes';
import type { ImplementedCopilotFeatures } from '../store/store';

export function isImplementedScenario(
    scenarioEnum: Scenario
): ImplementedCopilotFeatures | undefined {
    switch (scenarioEnum) {
        case Scenario.Coach:
            return 'Coach';
        case Scenario.Elaborate:
            return 'Elaborate';
        case Scenario.ThreadSummarization:
            return 'Summarize';
        case Scenario.SuggestedDrafts:
            return 'SuggestedDrafts';
        case Scenario.ExplainPlacesReport:
            return 'ExplainPlacesReport';
        case Scenario.Rewrite:
            return 'Rewrite';
        case Scenario.ReplyByMeeting:
            return 'ReplyByMeeting';
        case Scenario.MeetingPrepSummary:
            return 'MeetingPrepSummary';
        case Scenario.Chat:
            return 'Chat';
        case Scenario.CoachApply:
            return 'CoachApply';
        case Scenario.InboxCatchup:
            return 'Inbox';
        case Scenario.TimeCopilotChat:
            return 'TimeCopilotChat';
        case Scenario.ThemeVisualization:
            return 'VisualTheming';
        case Scenario.MChat:
            return 'MChat';
        case Scenario.AgendaGeneration:
            return 'AgendaGeneration';
        case Scenario.AttachmentSummarization:
            return 'AttachmentSummarization';
        case Scenario.AutoResourceBooking:
            return 'AutoResourceBooking';
        case Scenario.AttendeeColocation:
            return 'AttendeeColocation';
        case Scenario.RSVPSuggestions:
            return 'RSVPSuggestions';
        case Scenario.ManagedEvents:
            return 'ManagedEvents';
        case Scenario.PriorityCalendar:
            return 'PriorityCalendar';
        case Scenario.CalendarInstructions:
            return 'CalendarInstructions';
        default:
            return undefined;
    }
}
